module.exports = "/lmstools/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?d10ac4ee5ebe8c8fff90505150ba2a76";